import React from "react";
import backdrop from "../../assets/homepageBackdrop.jpg";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <>
      <section
        style={{
          backgroundImage: `url(${backdrop})`, // Bowling alley image
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "white",
          padding: "6rem 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Color Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(2, 108, 134, 0.7) 50%, rgba(0,0,0,0.8) 100%)",
            zIndex: 1,
          }}
        ></div>

        {/* Additional subtle overlay for depth */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(90deg, transparent, rgba(255, 0, 0, 0.1), transparent)",
            opacity: 0.3,
            zIndex: 2,
          }}
        ></div>

        {/* Content */}
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 1.5rem",
            textAlign: "center",
            position: "relative",
            zIndex: 3,
          }}
        >
          <h1
            style={{
              fontSize: "3.5rem",
              fontWeight: "bold",
              marginBottom: "1.5rem",
              textShadow: "2px 2px 8px rgba(0,0,0,0.8)",
              lineHeight: "1.2",
            }}
          >
            Professional Bowling Equipment & Services
          </h1>
          <p
            style={{
              fontSize: "1.25rem",
              marginBottom: "2.5rem",
              maxWidth: "700px",
              margin: "0 auto 2.5rem auto",
              color: "#f0f0f0",
              lineHeight: "1.6",
              textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
            }}
          >
            Your premier destination for precision bowling equipment, expert
            drilling, and professional services. Elevate your game with our
            cutting-edge technology and decades of experience.
          </p>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "1rem",
              marginTop: "1.5rem",
            }}
          >
            <button
              style={{
                background: "linear-gradient(45deg, #0891b2, #22d3ee)",
                boxShadow: "0 4px 15px rgba(8, 145, 178, 0.4)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "1px",
                padding: "1rem 2rem",
                minWidth: "220px",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 6px 20px rgba(8, 145, 178, 0.6)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 4px 15px rgba(8, 145, 178, 0.4)";
              }}
              onClick={() => navigate("/service")}
            >
              Explore Our Services
            </button>

            <button
              style={{
                background: "linear-gradient(45deg, #0891b2, #22d3ee)",
                boxShadow: "0 4px 15px rgba(8, 145, 178, 0.4)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "1px",
                padding: "1rem 2rem",
                minWidth: "220px",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 6px 20px rgba(8, 145, 178, 0.6)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 4px 15px rgba(8, 145, 178, 0.4)";
              }}
              onClick={() => navigate("/balls")}
            >
              View Bowling Ball Catalog
            </button>

            <button
              style={{
                background: "linear-gradient(45deg, #0891b2, #22d3ee)",
                boxShadow: "0 4px 15px rgba(8, 145, 178, 0.4)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "1px",
                padding: "1rem 2rem",
                minWidth: "220px",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 6px 20px rgba(8, 145, 178, 0.6)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 4px 15px rgba(8, 145, 178, 0.4)";
              }}
              onClick={() => navigate("/shoes")}
            >
              View Shoes Catalog
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
